export const HEADER_NOTIFICATION_URL = 'anonym/notifications/get_text_for_notification_in_header';
export const HEADER_NOTIFICATION_MARK_AS_READ_URL = 'anonym/notifications/:id/add_view';

export const HEADER_NOTIFICATION_QUERY_KEY = 'header-notification';
export const HEADER_NOTIFICATION_MARK_AS_READ_QUERY_KEY = 'header-notification.mark-view';
